import { SxProps, TableHead, useTheme } from "@mui/material"
import { RPMTableHeaderRow } from "../../../shared/table/RPMTableHeaderRow"
import { RPMTableHeaderCell } from "../../../shared/table/RPMTableHeaderCell"

export const ScheduleEventsHeader = () => {

    const theme = useTheme();

    const cellProps: SxProps = { backgroundColor: theme.palette.grey[200] };

    return (
        <TableHead>
            <RPMTableHeaderRow>
                <RPMTableHeaderCell sx={cellProps}>Category</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Meeting</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Time</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Race No</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Event</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Country</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Event Status</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Price Status</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Current Phase</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Suspension Status</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Derivatives Status</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Last Updated</RPMTableHeaderCell>
            </RPMTableHeaderRow>
        </TableHead>
    )
}
